import { Sizes } from "../../components/Sizes";

export const SizesPage = () => {
  return (
    <div className="container__pages">
      <h2>Lista de tallas</h2>
      <div className="container_form">
        <Sizes />
      </div>
    </div>
  );
};
